export const CountryCode = {
  Canada: 'CA',
};
